import IrpAppService from '../../../../application/platform/scp/irp/irp-app-service';
import { FileAttachmentsTable } from '../../shared/file-attachments-table';
import { FileAttachmentsService } from '../../shared/use-file-attachments';

const IRP_FILES_SERVICE: FileAttachmentsService = {
    documentTypeGroup: 6,
    list: (id) => IrpAppService.listIrpFiles({ id, page: 1, pageSize: 200 }),
    add: IrpAppService.addFileIrp,
    remove: IrpAppService.deleteFileIrp,
};

export default function IrpFileDataTable({ irpId }: { irpId?: string }) {
    return <FileAttachmentsTable entityId={irpId ? Number(irpId) : undefined} service={IRP_FILES_SERVICE} uploadId="file-upload-atachment-irp" />;
}
